import { Record, List, Map } from 'immutable';

export const ChatUserFactory = new Record({
  chatToken: '',
  username: '',
  userId: '',
  userGUID: '',
  role: '',
  picture: '',
  isSupport: false,
  firstName: '',
  lastName: '',
  limited: false,
  restricted: false,
});

export const ChatFactory = new Record({
  // shared fields
  users: new List(),
  activeChannel: null,
  activeChannelForce: null,
  readyToRenderOnDocument: false,
  isOpen: false,
  // UIKit handles its own loading; defaulting to true avoids disabling the unread sort chip
  loaded: true,
  isOneSignalInit: false,
  channelUrl: '',
  targetTimestamp: null,
  targetMessageId: null,
  usersCompanyId: '',

  // v3-only fields (inert when enable_chat_v2=true)
  threads: new Map(),
  messageQuery: new Map(),
  channels: new Map(),
  company: new Map(),
  // null = initial bootstrap (no connect attempt made yet). Distinguishes from
  // RECONNECTING/FAILED which are dispatched only by Sendbird's reconnect handlers
  // after a real drop. Lets ChatStatusAlert stay silent until there's a genuine
  // reconnect event to report (instead of flashing on first chat-panel open).
  connectionStatus: null,
  isOnPage: false,
  allowedWorker: false,
  messageHandlerId: null,

  // v4-only fields (inert when enable_chat_v2=false)
  unreadDocuments: new Map(),
  unreadCompanies: new Map(),
  totalUnreadCount: 0,
});

export function ChatAdapter(data) {
  return List(
    data.map((rawUser) => {
      const { displayName: username, userID: userId, userGUID = '', first_name: firstName, last_name: lastName, ...rest } = rawUser;
      const user = { username, userId, userGUID, firstName, lastName, ...rest };
      return ChatUserFactory(user);
    }),
  );
}
